<template>
<div class="container-fluid mt-12">
    <div>
        <header class="header" id="header">
            <div style="display: flex; justify-content:center; align-items: center;">
                <div @click="close" id="togg" class="header_toggle"><i class='bx bx-x bx-menu' id="header-toggle"></i>
                </div>
                <div class="namet" style="margin-top:5px">Welcome Appmart Admin</div>
            </div>
            <div style="display: flex; justify-content:center; align-items: center;">
                <div class="namet2" style="color:#fff; font-size:12px"></div>
                <div class="ml-4 header_img" style="background:#c7e7fb"> </div>
            </div>
        </header>
        <div class="l-navbar" id="nav-bar" style="background-color:#101a42;">
            <nav class="">
                <div>
                    <a style="text-decoration:none; padding-left:15% " class=""><span class="">
                            <img src="../../assets/pngwhite.png" width="150"><br><br> 
                        </span>
                    </a>
                    <div style="text-decoration:;color:white; font-size:13px; text-align:center" class="">
                        <strong style="font-size:18px">Agent console</strong><br>
                        
                    </div>

                    <div class="nav_list" style="margin-top:50px">
                        <ul style="padding: 0%; margin: 0%" class="list-unstyled components">
                            <li><a href="#/dashboard" style="text-decoration:none; " class="nav_link"><i class="fas fa-columns"></i> <span class="nav_name">Dashboard</span>
                                </a></li>
                            <li class="">

                            </li>
                            <li><a href="#/configure" style="text-decoration:none; " class="nav_link"><i class='bx bx-user'></i> <span class="nav_name">Transactions</span>
                                </a></li>
                            <li><a href="#/createAgent" style="text-decoration:none; " class="nav_link"><i class='bx bx-user'></i> <span class="nav_name">Create Agent</span>
                                </a></li>
                            <li><a href="#/listAllAgent" style="text-decoration:none; " class="nav_link"><i class='bx bx-user'></i> <span class="nav_name">Agents</span>
                                </a></li>
                        </ul>
                    </div>
                </div> <a style="text-decoration:none" href="#/" class="nav_link"> <i class='bx bx-log-out nav_icon'></i> <span class="nav_name">SignOut</span> </a>

            </nav>
        </div>
    </div>
    <div id="bodyPd" class="body-pd height-100 bg-light">
        <router-view style="padding:30px">

        </router-view>
    </div>
</div>
</template>

<script>
import $ from "jquery"

export default {
    data() {
        return {
            subMenu: false,
            configuremenu: false,
            userDetail: '',

        }
    },
    beforeMount() {

    },
    mounted() {
        if(!this.$cookies.isKey('_zVa234')){
            this.$router.push({ name:'signin'})
        }
        $(document).ready(function () {
            $('#sidebarCollapse').on('click', function () {
                $('#sidebar').toggleClass('active');
            });
        });
        window.addEventListener('load', () => {

            const showNavbar = (toggleId, navId, bodyId, headerId) => {
                const toggle = document.getElementById(toggleId),
                    nav = document.getElementById(navId),
                    bodypd = document.getElementById(bodyId),
                    headerpd = document.getElementById(headerId)

                // Validate that all variables exist
                if (toggle && nav && bodypd && headerpd) {
                    toggle.addEventListener('click', () => {
                        // show navbar
                        nav.classList.toggle('show')
                        // change icon
                        toggle.classList.toggle('bx-x')
                        // add padding to body
                        bodypd.classList.toggle('body-pd')
                        // add padding to header
                        headerpd.classList.toggle('body-pd')
                    })
                }
            }

            showNavbar('header-toggle', 'nav-bar', 'body-pd', 'header')

            /*===== LINK ACTIVE =====*/
            const linkColor = document.querySelectorAll('.nav_link')

            function colorLink() {
                if (linkColor) {
                    linkColor.forEach(l => l.classList.remove('active'))
                    this.classList.add('active')
                }
            }
            linkColor.forEach(l => l.addEventListener('click', colorLink))

            // Your code to run since DOM is loaded and ready
        });
    },

    methods: {
        hideShow() {
            this.subMenu = true
        },

        close() {
            // document.getElementById("nav-bar").classList.remove('l-navbar');
            document.getElementById("nav-bar").classList.toggle('l-navbar2');
            // document.getElementById("bodyPd").classList.remove('body-pd');
            document.getElementById("bodyPd").classList.toggle('body-pd2');
            document.getElementById("header").classList.toggle('body-pd3');
            document.getElementById("header-toggle").classList.toggle('bx-x')
            document.getElementById("togg").classList.toggle('header_toggle2')
        },
        information(x) {
            this.names = x.data.full_name
            const configure = x.data.permissions.find(element => element == 'access_configure_module');
            if (configure != undefined) {
                this.configuremenu = true
            }
            console.log(x);
        },

    }
}
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap");
@import "https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700";

*,
::before,
::after {
    box-sizing: border-box
}

#bodyPd{
    overflow-y: scroll;
}

body {
    position: relative;
    margin: 3rem 0 0 0;
    padding: 0 1rem;
    font-family: 'Nunito', sans-serif;
    font-size: 1rem;
    transition: .5s
}

a {
    text-decoration: none
}

.header {
    width: 100%;
    height: 3rem;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
    background-color: #165F89;
    z-index: 100;
    transition: .5s
}

.namet {
    color: #fff;
    margin-left: 2rem;
}

.header_toggle {
    color: #fff;
    font-size: 1.5rem;
    cursor: pointer;
    transition: .5s;
}

.header_toggle2 {
    color: #fff;
    font-size: 1.5rem;
    cursor: pointer;
    // padding-left: 240px;
}

.header_img {
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    border-radius: 50%;
    overflow: hidden
}

.header_img img {
    width: 40px
}

.l-navbar {
    position: fixed;
    top: 0;
    left: -20%;
    width: 224px;
    height: 100vh;
    background-color: #4A869F;
    padding: .5rem 1rem 0 0;
    transition: .5s;
    z-index: 100
}

.l-navbar2 {
    position: fixed;
    top: 0;
    left: 0;
    width: 68px;
    height: 100vh;
    background-color: #4A869F;
    padding: 1rem 1rem 0 0;
    transition: .5s;
    z-index: 100
}

body {
    font-family: 'Poppins', sans-serif;
    background: #fafafa;
}

p {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1em;
    font-weight: 300;
    line-height: 1.7em;
    color: #999;
}

a,
a:hover,
a:focus {
    color: inherit;
    text-decoration: none;
    transition: all 0.3s;
}

.navbar {
    padding: 15px 10px;
    background: #fff;
    border: none;
    border-radius: 0;
    margin-bottom: 40px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
}

.navbar-btn {
    box-shadow: none;
    outline: none !important;
    border: none;
}

.line {
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #ddd;
    margin: 40px 0;
}

/* ---------------------------------------------------
        SIDEBAR STYLE
    ----------------------------------------------------- */

#sidebar ul.components {
    padding: 20px 0;
    border-bottom: 1px solid #47748b;
}

#sidebar ul p {
    color: #fff;
    padding: 10px;
}

#sidebar ul li a {
    color: #fff;
    text-decoration: none;
    padding: 10px;
    font-size: 1.1em;
    display: block;
}

#sidebar ul li a:hover {
    color: #fff;
    background: #4A869F;
}

#sidebar ul li.active>a,
a[aria-expanded="true"] {
    color: #000;
    background: #4A869F;
}

a[data-toggle="collapse"] {
    position: relative;
}

.dropdown-toggle::after {
    display: block;
    position: absolute;
    top: 50%;
    right: 2rem;
    transform: translateY(-50%);
    color: #000;
    background: #4A869F;
}

ul ul a {
    font-size: 0.9em !important;
    padding-left: 30px !important;
    color: #000;
    background: #4A869F;
}

ul.CTAs {
    padding: 20px;
}

ul.CTAs a {
    text-align: center;
    font-size: 0.9em !important;
    display: block;
    border-radius: 5px;
    margin-bottom: 5px;
}

a.download {
    background: #fff;
    color: #7386D5;
}

a.article,
a.article:hover {
    background: #6d7fcc !important;
    color: #fff !important;
}

/* ---------------------------------------------------
        CONTENT STYLE
    ----------------------------------------------------- */

#content {
    width: 100%;
    padding: 20px;
    min-height: 100vh;
    transition: all 0.3s;
}

/* ---------------------------------------------------
        MEDIAQUERIES
    ----------------------------------------------------- */

@media (max-width: 768px) {
    #sidebar {
        margin-left: -250px;
    }

    #sidebar.active {
        margin-left: 0;
    }

    #sidebarCollapse span {
        display: none;
    }

    .dropdown-toggle::after {
        display: block;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        color: #fff;
        background: #4A869F;
    }
}

.nav {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden
}

.nav_logo,
.nav_link {
    display: grid;
    grid-template-columns: max-content max-content;
    align-items: center;
    column-gap: 1rem;
    padding: .5rem 0 .5rem 1.5rem
}

.nav_link2 {
    display: grid;
    grid-template-columns: max-content max-content;
    align-items: center;
    column-gap: 1rem;
    margin-left: 1.5rem;
    padding: .5rem 0 .5rem 1.5rem
}

.nav_logo {
    margin-bottom: 2rem
}

.nav_logo-icon {
    font-size: 1.25rem;
    color: #fff
}

.nav_logo-name {
    color: #fff;
    font-weight: 700
}

.nav_link {
    position: relative;
    color: #fff;
    margin-bottom: .5rem;
    transition: .3s
}

.nav_link:hover {
    color: #000
}

.nav_icon {
    font-size: 1.25rem
}

.show {
    left: 0
}

.active {
    color: #000
}

.active::before {
    content: '';
    position: absolute;
    left: -230px;
    width: 2px;
    height: 32px;
    background-color: #000
}

.height-100 {
    height: 100vh
}

@media (min-width: 768px) {
    body {
        margin: 4rem 0 0 0;
        padding-left: 16rem;
    }

    .header {
        height: 4rem;
        padding: 0 2rem 0 15rem
    }

    .header_img {
        width: 40px;
        height: 40px
    }

    .header_img img {
        width: 45px
    }

    .l-navbar {
        left: 0;
        padding: 1rem 1rem 0 0
    }

    .show {
        width: 380px
    }

    .body-pd {
        padding-left: 210px;
        transition: .5s;

    }

    .body-pd2 {
        padding-left: 20px;
        transition: .5s;
    }

    .body-pd3 {
        padding-left: 80px;
        transition: .5s;
    }
}

@media(min-width: 320px) and (max-width: 1200px) {
    body {
        margin: 4rem 0 0 0;
        padding-left: 16rem;
    }

    .namet {
        // color: #fff;
        // margin-left: 2rem;
        // font-size: 10px;
        display: none;

    }

    .namet2 {
        // color: #fff;
        // font-size: 10px;
        display: none;
    }

    .header {
        height: 4rem;
        padding: 0 2rem 0 15rem
    }

    .header_img {
        width: 40px;
        height: 40px
    }

    .header_img img {
        width: 45px
    }

    .l-navbar {
        left: 0;
        padding: 1rem 1rem 0 0
    }

    .show {
        width: 380px
    }

    .body-pd {
        padding-left: 0px;
        transition: .5s;
    }

    .body-pd2 {
        padding-left: 0px;
        transition: .5s;
    }

    .body-pd3 {
        padding-left: 240px;
        transition: .5s;
    }

    .header_toggle {
        color: #fff;
        font-size: 1.5rem;
        cursor: pointer;
        transition: .5s;
    }

    .header_toggle2 {
        color: #fff;
        font-size: 1.5rem;
        cursor: pointer;
        padding-left: 224px;
        transition: .5s;
    }

    .l-navbar {
        position: fixed;
        top: 0;
        left: 0%;
        width: 0%;
        height: 100vh;
        background-color: #4A869F;
        padding: .5rem 1rem 0 0;
        transition: .5s;
        z-index: 100
    }

    .l-navbar2 {
        position: fixed;
        top: 0;
        left: 0;
        width: 224px;
        height: 100vh;
        background-color: #4A869F;
        padding: 1rem 1rem 0 0;
        transition: .5s;
        z-index: 100
    }

    .header {
        width: 100%;
        height: 3rem;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 1rem;
        background-color: #4A869F;
        z-index: 100;
        transition: .5s
    }
}
</style>
